import { v4 as uuidv4 } from 'uuid';
import is from 'is_js';

const initialState = {
    isError: false,
    isLoadingLabResults: false,
    labResults: null,
    isLoadingImmunizationResults: false,
    isLoadingLabResultsPdf: false,
    isLoadingDemographics: false,
    immunizationResults: [],
    selectedLabResult: null,
    user: null,
    errorMessage: null,
    deviceId: null,
    deviceType: null,
}

export default function api(state = initialState, action) {
    switch(action.type) {
        case "FETCH_DEMOGRAPHICS":
            return {
                ...state,
                isLoadingDemographics: true,
                isError: false,
            }
        case "FETCH_LAB_RESULTS":
            return {
                ...state,
                isLoadingLabResults: true,
                isError: false,
            }
        case "FETCH_RESULTS_PDF":
                return {
                    ...state,
                    isLoadingLabResultsPdf: true,
                    isError: false,
                }
        case "RECEIVE_RESULTS_PDF":
                    return {
                        ...state,
                        isLoadingLabResultsPdf: false,
                        isError: false,
                    }
        case "RECEIVE_DEMOGRAPHICS":
                    return {
                        ...state,
                        isLoadingDemographics: false,
                        isError: false,
                    }
        case "RECEIVE_LAB_RESULTS":
            return {
                ...state,
                isLoadingLabResults: false,
                isError: false,
                labResults: action.data,
            }
        case "FETCH_IMMUNIZATION_RESULTS":
            return {
                ...state,
                isLoadingImmunizationResults: true,
                immunizationResults: [],
            }
        case "RECEIVE_IMMUNIZATION_RESULTS":
            return {
                ...state,
                isLoadingImmunizationResults: false,
                isError: false,
                immunizationResults: action.data,
            }
        case "CLEAR_DATA":
            return {
                ...state,
                isLoadingLabResults: false,
                isLoadingImmunizationResults: false,
                isError: false,
                labResults: null,
                selectedLabResult: null,
                immunizationResults: [],
                user: null,
            }
        case "SET_SELECTED_LAB_RESULT":
            return {
                ...state,
                selectedLabResult: action.data,
            }
        case "SET_USER":
            return {
                ...state,
                user: action.data,
            }
        case "FETCH_DEVICE_TYPE":
            if(is.desktop()){
                return {
                    ...state,
                    deviceType: 'Desktop',
                }
            } else if(is.mobile()){
                return {
                    ...state,
                    deviceType: 'Mobile',
                }
            } else if(is.tablet()){
                return {
                    ...state,
                    deviceType: 'Tablet',
                };
            } else{
                return {
                    ...state,
                    deviceType: 'Unknown',
                };
            }
        case "CREATE_DEVICE_ID":
            if (state.deviceId === null) {
                let deviceId = uuidv4();
                return {
                    ...state,
                    deviceId: deviceId,
                }
            } else {
                return {
                    ...state,
                }
            }
        case "FETCH_ERROR":
            return {
                ...state,
                isLoadingLabResults: false,
                isLoadingUsers: false,
                isLoadingImmunizationResults: false,
                immunizationResults: [],
                isError: true,
                errorMessage: action.error,
            }
        case "SET_ERROR_STATE":
            if (action.fetch === true) {
                return {
                    ...state,
                    isLoadingLabResults: false,
                    isLoadingUsers: false,
                    isLoadingImmunizationResults: false,
                    immunizationResults: [],
                    isError: true,
                    errorMessage: action.error,
                }
            } else {
                return {
                    ...state,
                    isError: action.state,
                    errorMessage: action.error,
                }
            }
        default:
            return state;
    }
}
